import React from 'react'

import AssetFiltersList from '../../../../containers/assets/filters/AssetFiltersList'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="assets" open={open}>
      <AssetFiltersList />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
